export default __webpack_public_path__ + "static/media/8824.d4e8b78e.svg";